<template>
    <div id="app">
        <head-wrap></head-wrap>
        <div class="body-wrap">
            <body-wrap></body-wrap>
            <transition enter-active-class="animated fadeIn"
                        leave-active-class="animated fadeOut">
                <router-view class="view-wrap"></router-view>
            </transition>
        </div>
        <foot-wrap></foot-wrap>
        <svg-template></svg-template>
    </div>
</template>
<script>
    import SvgTemplate from './components/svg-template.vue'
    import HeadWrap from './components/head-wrap.vue'
    import BodyWrap from './components/body-wrap.vue'
    import FootWrap from './components/foot-wrap.vue'
    export default {
        name: 'app',
        computed: {
            animateName () {
                return this.$store.state.animate_name;
            },
        },

        components: {
            SvgTemplate,
            HeadWrap,
            BodyWrap,
            FootWrap,
        }
    }
</script>
<style lang="scss">
    @import "./assets/scss/reset";
    @import "./assets/scss/common";
    #app{
        @extend %df;
        flex-direction: column;
    }
    .body-wrap{
        @extend %w100;
        @extend %df1;
        @extend %pr;
    }
    .view-wrap{
        @extend %pa;
        @extend %l0;
        @extend %b0;
        @extend %t0;
        right: -15px;
        overflow-y: scroll;
    }
    .view-inner{

    }
</style>



// WEBPACK FOOTER //
// src/App.vue